import { promoteUrl } from "@/utils/url";
export default {
  name: "pagesHeaderH5",
  props: {
    'title': {
      type: String,
      default: ''
    },
    'backTo': {
      type: String,
      default: ''
    }
  },
  setup(props) {
    let goBack = () => {
      if (!!props.backTo) {
        window.location = promoteUrl() + '/' + props.backTo;
      } else {
        history.back();
      }
    };
    return {
      goBack
    };
  }
};